module.exports = __webpack_public_path__ + "static/incography2-a2dd6679e9650492835a35f1b69b4293.png";